import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=0db8836e&"
import script from "./Analysis.vue?vue&type=script&lang=ts&"
export * from "./Analysis.vue?vue&type=script&lang=ts&"
import style0 from "./Analysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports